import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ReactGA from "react-ga4";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';
const google_analytics_key = process.env.REACT_APP_GOOGLE_ANALYTICS_KEY;
const root = ReactDOM.createRoot(document.getElementById('root'));

const client = new QueryClient()
ReactGA.initialize(google_analytics_key);

const POSTHOG_API_KEY = process.env.REACT_APP_POSTHOG_API_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://app.posthog.com';

posthog.init(POSTHOG_API_KEY, {
  api_host: POSTHOG_HOST,
  // debug: true,
  autocapture: false,
  capture_pageview: false,
});

// posthog.onFeatureFlags(() => {
//   console.log("Flags loaded", posthog.getFeatureFlag("hero_accredian_home_ab"));
// });


root.render(

  <QueryClientProvider client={client}>
    <PostHogProvider client={posthog}>

      <BrowserRouter basename={window.location.pathname.startsWith('/legacy') ? '/legacy' : ''}>
        <App />
      </BrowserRouter>
    </PostHogProvider>
  </QueryClientProvider>

);
const SendAnalytics = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(SendAnalytics);
